import { Fragment } from "react";
import { Tag } from "primereact/tag";

import {
  CUSTOS_COL_ESCOPO,
  CUSTOS_COL_MATERIAL,
  CUSTOS_COL_SERVICOS,
  CUSTOS_COL_TOTAL,
  CUSTOS_DOMINANTE,
  CUSTOS_SEM_ESCOPO,
  CUSTOS_TOTAL_FACILIDADES,
  CUSTOS_TOTAL_MACRO,
  CUSTOS_TOTAL_OBRA,
} from "./ficha-custos-table.constants";
import styles from "./ficha-custos-table.module.scss";
import type { FichaCustosTableViewModel } from "./types-ficha-custos-table";

/** Escopo macro da obra por tipo, com Material, Serviços e Total (zerados por enquanto) e os totais. */
export function FichaCustosTableView({ linhas, alternar, valorZero }: FichaCustosTableViewModel) {
  const celulasDeValor = (
    <>
      <td className={styles.valor}>{valorZero}</td>
      <td className={styles.valor}>{valorZero}</td>
      <td className={styles.valor}>{valorZero}</td>
    </>
  );

  return (
    <div className={styles.root} data-testid="ficha-custos">
      <div className={styles.rolagem} data-testid="ficha-custos-rolagem">
        <table className={styles.tabela}>
          <thead>
            <tr>
              <th scope="col" className={styles.cabecalho}>
                {CUSTOS_COL_ESCOPO}
              </th>
              <th scope="col" className={styles.cabecalhoValor}>
                {CUSTOS_COL_MATERIAL}
              </th>
              <th scope="col" className={styles.cabecalhoValor}>
                {CUSTOS_COL_SERVICOS}
              </th>
              <th scope="col" className={styles.cabecalhoValor}>
                {CUSTOS_COL_TOTAL}
              </th>
            </tr>
          </thead>
          <tbody>
            {linhas.map((tipo) => (
              <Fragment key={tipo.id}>
                <tr data-testid={tipo.testIds.linha}>
                  <td className={styles.nome}>
                    <span className={styles.nomeLinha}>
                      <button
                        type="button"
                        className={styles.seta}
                        aria-expanded={tipo.aberto}
                        aria-label={tipo.rotuloToggle}
                        onClick={() => alternar(tipo.id)}
                        data-testid={tipo.testIds.toggle}
                      >
                        <i className={tipo.icone} aria-hidden />
                      </button>
                      <span className={styles.codigo}>{tipo.codigo}</span>
                      <span className={styles.titulo}>{tipo.nome}</span>
                      {tipo.dominante ? (
                        <Tag
                          value={CUSTOS_DOMINANTE}
                          severity="info"
                          className={styles.dominante}
                        />
                      ) : null}
                    </span>
                  </td>
                  {celulasDeValor}
                </tr>
                {tipo.aberto && tipo.escoposMacro.length === 0 ? (
                  <tr data-testid={tipo.testIds.vazio}>
                    <td className={styles.escopo}>{CUSTOS_SEM_ESCOPO}</td>
                    {celulasDeValor}
                  </tr>
                ) : null}
                {tipo.aberto
                  ? tipo.escoposMacro.map((escopo) => (
                      <tr key={escopo.id} data-testid={escopo.testId}>
                        <td className={styles.escopo}>{escopo.nome}</td>
                        {celulasDeValor}
                      </tr>
                    ))
                  : null}
              </Fragment>
            ))}
            <tr className={styles.resumo}>
              <td className={styles.resumoRotulo}>{CUSTOS_TOTAL_MACRO}</td>
              <td colSpan={3} className={styles.valor}>
                {valorZero}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <dl className={styles.totais}>
        <div className={styles.total}>
          <dt>{CUSTOS_TOTAL_FACILIDADES}</dt>
          <dd>{valorZero}</dd>
        </div>
        <div className={styles.total}>
          <dt>{CUSTOS_TOTAL_OBRA}</dt>
          <dd>{valorZero}</dd>
        </div>
      </dl>
    </div>
  );
}
